module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "personal-center-form__section"
  }, [_c('h1', {
    staticClass: "personal-center-form__title repayment_h1"
  }, [_vm._v("凭证详情\n      "), _vm._v(" "), (this.$route.query.type != 1) ? _c('span', {
    staticClass: "ask-time"
  }, [_vm._v("申请时间　" + _vm._s(_vm.applyDate))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "repayment-top",
    staticStyle: {
      "background": "#fff",
      "padding": "15px"
    },
    attrs: {
      "id": "frontVoucherInfoBox"
    }
  }, [_c('el-form', {
    ref: "step3list",
    staticClass: "financing-dialog-form-body",
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.typeStr),
      callback: function($$v) {
        _vm.typeStr = $$v
      },
      expression: "typeStr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "买方",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.infoData.buyerName),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "buyerName", $$v)
      },
      expression: "infoData.buyerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "stateName",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.infoData.stateName),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "stateName", $$v)
      },
      expression: "infoData.stateName"
    }
  })], 1), _vm._v(" "), (_vm.infoData.type != 7) ? _c('el-form-item', {
    attrs: {
      "label": "开票日期",
      "inline-message": "true"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "width": "265px",
      "disabled": _vm.isDisabled,
      "value-format": "yyyy-MM-dd",
      "placeholder": ""
    },
    model: {
      value: (_vm.infoData.accountsReceivableStartTime),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "accountsReceivableStartTime", $$v)
      },
      expression: "infoData.accountsReceivableStartTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('accountsReceivableEndTime')) ? _c('el-form-item', {
    attrs: {
      "label": "汇票到期日",
      "inline-message": "true"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "disabled": _vm.isDisabled,
      "value-format": "yyyy-MM-dd",
      "placeholder": ""
    },
    model: {
      value: (_vm.infoData.accountsReceivableEndTime),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "accountsReceivableEndTime", $$v)
      },
      expression: "infoData.accountsReceivableEndTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    class: this.infoData.type == 5 || this.infoData.type == 6 ? 'form-item-change' : '',
    attrs: {
      "label": _vm.bizNoName,
      "inline-message": "true"
    }
  }, [(_vm.infoData.type != 7) ? _c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.infoData.bizNo),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "bizNo", $$v)
      },
      expression: "infoData.bizNo"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.infoData.type != 7) ? _c('el-form-item', {
    attrs: {
      "label": _vm.receivableAmountName,
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.infoData.accountsReceivableAmount),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "accountsReceivableAmount", $$v)
      },
      expression: "infoData.accountsReceivableAmount"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应收账款净额",
      "prop": "netAmount"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.infoData.netAmount),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "netAmount", $$v)
      },
      expression: "infoData.netAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品名称",
      "prop": "baseProductId"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.infoData.baseProductId),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "baseProductId", $$v)
      },
      expression: "infoData.baseProductId"
    }
  }, _vm._l((_vm.productList), function(item) {
    return _c('el-option', {
      key: item.productId,
      attrs: {
        "label": item.productName,
        "value": item.productId
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.showRule.includes('contractNumber')) ? _c('el-form-item', {
    attrs: {
      "label": "合同编号",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.infoData.contractNumber),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "contractNumber", $$v)
      },
      expression: "infoData.contractNumber"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('orderNo')) ? _c('el-form-item', {
    attrs: {
      "label": "订单号",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.orderData.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.orderData, "orderNo", $$v)
      },
      expression: "orderData.orderNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('deliveryNo')) ? _c('el-form-item', {
    attrs: {
      "label": "送货单号",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.orderData.deliveryNo),
      callback: function($$v) {
        _vm.$set(_vm.orderData, "deliveryNo", $$v)
      },
      expression: "orderData.deliveryNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('receiptNo')) ? _c('el-form-item', {
    attrs: {
      "label": "收货单号",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.orderData.receiptNo),
      callback: function($$v) {
        _vm.$set(_vm.orderData, "receiptNo", $$v)
      },
      expression: "orderData.receiptNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('goodsName')) ? _c('el-form-item', {
    attrs: {
      "label": "品名",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.orderData.goodsName),
      callback: function($$v) {
        _vm.$set(_vm.orderData, "goodsName", $$v)
      },
      expression: "orderData.goodsName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('spec')) ? _c('el-form-item', {
    attrs: {
      "label": "规格",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.orderData.spec),
      callback: function($$v) {
        _vm.$set(_vm.orderData, "spec", $$v)
      },
      expression: "orderData.spec"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('unit')) ? _c('el-form-item', {
    attrs: {
      "label": "单位",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.orderData.unit),
      callback: function($$v) {
        _vm.$set(_vm.orderData, "unit", $$v)
      },
      expression: "orderData.unit"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('unitPrice')) ? _c('el-form-item', {
    attrs: {
      "label": "单价",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.orderData.unitPrice),
      callback: function($$v) {
        _vm.$set(_vm.orderData, "unitPrice", $$v)
      },
      expression: "orderData.unitPrice"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('num')) ? _c('el-form-item', {
    attrs: {
      "label": "数量",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.orderData.num),
      callback: function($$v) {
        _vm.$set(_vm.orderData, "num", $$v)
      },
      expression: "orderData.num"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('totalPrice')) ? _c('el-form-item', {
    attrs: {
      "label": "总价",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.orderData.totalPrice),
      callback: function($$v) {
        _vm.$set(_vm.orderData, "totalPrice", $$v)
      },
      expression: "orderData.totalPrice"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('signDate')) ? _c('el-form-item', {
    attrs: {
      "label": "签署日期",
      "inline-message": "true"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "disabled": _vm.isDisabled,
      "value-format": "yyyy-MM-dd",
      "placeholder": ""
    },
    model: {
      value: (_vm.infoData.signDate),
      callback: function($$v) {
        _vm.$set(_vm.infoData, "signDate", $$v)
      },
      expression: "infoData.signDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('drawer')) ? _c('el-form-item', {
    staticClass: "form-item-change",
    attrs: {
      "label": "出票人全称",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.billData.drawer),
      callback: function($$v) {
        _vm.$set(_vm.billData, "drawer", $$v)
      },
      expression: "billData.drawer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('acceptor')) ? _c('el-form-item', {
    attrs: {
      "label": "承兑人全称",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.billData.acceptor),
      callback: function($$v) {
        _vm.$set(_vm.billData, "acceptor", $$v)
      },
      expression: "billData.acceptor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRule.includes('acceptorBank')) ? _c('el-form-item', {
    attrs: {
      "label": "承兑人开户行",
      "inline-message": "true"
    }
  }, [_c('el-input', {
    staticClass: "input-change",
    attrs: {
      "disabled": _vm.isDisabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.billData.acceptorBank),
      callback: function($$v) {
        _vm.$set(_vm.billData, "acceptorBank", $$v)
      },
      expression: "billData.acceptorBank"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.infoData.type != 7) ? _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "opacity": "0"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "file-list__item-list"
  }, [_vm._l((_vm.sysFileIds), function(file) {
    return [(/\.pdf|\.doc|\.rar|\.zip|\.7z/g.test(file.fileName)) ? _c('li', {
      class: ['file-list__item-preview', ("file-list__" + (file.fileName.substr(file.fileName.lastIndexOf('.')+1)) + "-preview")],
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.showPreviewImage(file.fileId, false)
        }
      }
    }, [_c('div', {
      staticClass: "file-list__file-name"
    }, [_vm._v(_vm._s(file.fileName))])]) : _c('li', {
      staticClass: "file-list__item-preview"
    }, [_c('img', {
      attrs: {
        "src": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=" + (file.fileId) + "&tokenId=" + _vm.tokenId)
      },
      on: {
        "click": function($event) {
          return _vm.showPreviewImage(file.fileId, true)
        }
      }
    })])]
  })], 2)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "file-preview-modal",
    attrs: {
      "title": "图片预览",
      "visible": _vm.filePreview.show,
      "before-close": _vm.hidePreviewImage,
      "close-on-click-modal": false
    }
  }, [_c('div', {
    staticClass: "file-preview-modal__body"
  }, [_c('img', {
    attrs: {
      "src": _vm.filePreview.src,
      "alt": "图片预览"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "dialog__footer__confirm-btn",
    on: {
      "click": _vm.hidePreviewImage
    }
  }, [_vm._v("确定")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b38c97f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/FrontVoucherInfo_pj.vue
// module id = 1048
// module chunks = 1